import Autocomplete from "@mui/material/Autocomplete";
import Chip from "@mui/material/Chip";
import TextField from "@mui/material/TextField";
import React from 'react';

type FilterAutocompleteProps = {
  filterName: string;
  placeholder: string;
  value: string | string[] | null;
  options?: string[];
  freeSolo?: boolean;
  multiple?: boolean;
  onChange: (filterName: string, value: string | string[] | null) => void;
};

export default function FilterAutocomplete(props: Readonly<FilterAutocompleteProps>) {
  const { 
    filterName, 
    placeholder, 
    freeSolo, 
    multiple, 
    options, 
    onChange,
    value
  } = props;

  return (
    <Autocomplete
      size="small"
      freeSolo={freeSolo}
      multiple={multiple}
      value={value}
      options={options ?? []}
      sx={{ width: '100%' }}
      onChange={(_event, val, _reason) => {
        onChange(
          filterName, 
          val
        );
      }}
      renderValue={(selected) => {
        let chips;
        if (Array.isArray(selected)) {
          chips = selected.map((option) => (
            <Chip
              key={option}
              size="small"
              label={option}
              sx={{ marginRight: 0.5 }}
            />
          ));
        } else if (selected) {
          chips = <Chip size="small" label={selected} />;
        } else {
          chips = null;
        }
        return chips;
      }}
      renderInput={(params) => (
        <TextField {...params}
          size="small"
          variant="outlined"
          placeholder={placeholder} />
      )}
    />
  )
}
